import { type PropsWithChildren } from "react";

import * as S from "./OuterField.styled";

export type OuterFieldProps = PropsWithChildren;

function OuterField(props: OuterFieldProps) {
  const { children } = props;

  return (
    <S.Container>
      <S.InnerContainer>{children}</S.InnerContainer>
    </S.Container>
  );
}

export default OuterField;
